import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import {
  AlertController,
  LoadingController,
  MenuController,
  Platform,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { TranslateConfigService } from './services/translate-config.service';
import { Storage } from '@ionic/storage-angular';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  selectedLanguage: string;
  pltActivated: boolean = false;
  protected app_version: string;
  user: any;
  constructor(
    private route: Router,
    private translateConfigService: TranslateConfigService,
    private menuCtrl: MenuController,
    private alertController: AlertController,
    private translateService: TranslateService,
    public storage: Storage,
    private router: Router,
    private loadingCtrl: LoadingController,
    private statusBar: StatusBar
  ) {
    this.selectedLanguage = translateConfigService.getDefaultLanguage();
  }

  async ngOnInit() {
    this.statusBar.overlaysWebView(false);
    await this.storage.create();
    await this.storage.get('language').then((val) => {
      if (val) {
        this.selectedLanguage = val;
        this.translateConfigService.setLanguage(val);
      }
    });
    this.route.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd && event.url === '/login') {
        this.menuCtrl.enable(false, 'custom');
      } else {
      }
    });

    await this.storage.get('hasLoggedIn').then((hasLoggedIn) => {
      if (!hasLoggedIn) {
        this.router.navigateByUrl('/login');
      }
    });
    this.getUser();
  }

  languageChanged() {
    this.translateConfigService.setLanguage(this.selectedLanguage);
    this.storage.set('language', this.selectedLanguage);
  }

  getUser() {
    this.storage.get('user').then((user) => {
      if (user) {
        this.user = user.username;
      }
    });
  }

  async logout() {
    this.translateService
      .get(['logout', 'logoutMessage', 'cancel', 'okay', 'loadingCtrl'])
      .subscribe(async (res) => {
        let alert = await this.alertController.create({
          header: res.logout,
          message: res.logoutMessage,
          buttons: [
            {
              text: res.cancel,
              role: 'cancel',
              cssClass: 'logoutCancel',
              handler: () => {},
            },
            {
              text: res.okay,
              cssClass: 'logoutOkay',
              handler: () => {
                this.storage.remove('user');
                this.storage.remove('hasLoggedIn');
                this.loadingCtrl
                  .create({
                    message: res.loadingCtrl,
                    spinner: 'bubbles',
                    animated: true,
                    translucent: true,
                  })
                  .then((loading) => loading.present())
                  .then(() => {
                    this.loadingCtrl.dismiss();
                    this.menuCtrl.enable(false, 'custom');
                    this.router.navigateByUrl('/', { replaceUrl: true });
                  });
              },
            },
          ],
        });
        alert.present();
      });
  }
}
